import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import { computed, ref } from 'vue';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { useMutation } from '@vue/apollo-composable';
import {
  OrganizationUserAssociationType,
  UserSwitchOrganizationDocument,
} from '@/gql/graphql';
import { useUserStore } from '@/store/user';

// --- Props for the component ---
interface Props {
  association: OrganizationUserAssociationType;
  show: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationActivate',
  props: {
    association: {},
    show: { type: Boolean }
  },
  emits: ['orgActivated', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const userStore = useUserStore();

// --- Computed Properties ---
const isActive = computed(() => {
  return (
    userStore.activeOrgAssociation?.organization?.id ===
    props.association.organization?.id
  );
});
const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Switch Active Organization ---
const mutationInProgress = ref(false);
const mutationShowSuccess = ref(false);
const mutationError = ref<string | null>(null);

const {
  mutate: userSwitchOrganizationMut,
  onDone: onUserSwitchOrganizationDone,
  onError: onUserSwitchOrganizationError,
} = useMutation(UserSwitchOrganizationDocument);

onUserSwitchOrganizationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.userSwitchOrganization) {
    console.debug('Organization switched:', res.data.userSwitchOrganization);
    mutationShowSuccess.value = true;
    emits('orgActivated', res.data.userSwitchOrganization.id);
    setTimeout(() => {
      mutationShowSuccess.value = false;
    }, 1000);
  } else {
    console.error('Organization switch failed:', res.data);
    mutationError.value = 'Organization switch failed: ' + res.data;
  }
});

onUserSwitchOrganizationError((err) => {
  console.error('Error switching organization:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handlers
function switchOrganization() {
  // Switch active organization
  mutationInProgress.value = true;
  mutationError.value = null;

  // Validate
  if (!props.association.organization?.id) {
    console.error('No organization to switch to');
    mutationInProgress.value = false;
    mutationError.value = 'No organization to switch to';
    return;
  }

  // Execute mutation
  console.log('Switching organization:', props.association.organization.id);
  userSwitchOrganizationMut({
    organizationId: props.association.organization.id,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (props.association.organization)
    ? (_openBlock(), _createBlock(_unref(BModal), {
        key: 0,
        class: "orgActivateModal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
        onHide: handleCloseModal
      }, {
        title: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'building'],
            class: "me-2"
          }),
          _createElementVNode("strong", null, _toDisplayString(props.association.organization.name), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_unref(BButton), {
            variant: "secondary",
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              (!isActive.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Cancel"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "Close"))
            ]),
            _: 1
          }),
          (!isActive.value)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 0,
                variant: "primary",
                disabled: mutationInProgress.value || mutationShowSuccess.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchOrganization()))
              }, {
                default: _withCtx(() => [
                  (mutationInProgress.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _cache[7] || (_cache[7] = _createTextVNode(" Activating Organization ", -1)),
                        _createVNode(_unref(BSpinner), {
                          small: "",
                          label: ""
                        })
                      ]))
                    : (mutationShowSuccess.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _cache[8] || (_cache[8] = _createTextVNode(" Organization Activated ", -1)),
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fa', 'check-double'],
                            class: "me-2"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, " Activate Organization "))
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (!isActive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", null, [
                    _cache[3] || (_cache[3] = _createTextVNode(" You are currently not active in this organization. Click the button below to switch your active organization context to ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(props.association.organization.name), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, [
                    _cache[5] || (_cache[5] = _createTextVNode(" You are currently active in this organization. Your role is ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(props.association.userRole), 1),
                    _cache[6] || (_cache[6] = _createTextVNode(". You may now access organization resources. ", -1))
                  ])
                ]))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})